import http from '@/utils/http'

export const getUploadFiles = (nodeID) => {
  const getUrl = `/kuiper/${nodeID}/config/uploads`
  return http.get(getUrl)
}

export const uploadFile = (nodeID, body = {}, isFormData) => {
  const url = `/kuiper/${nodeID}/config/uploads`
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  const h = !isFormData ? http.post(url, body) : http.post(url, body, config)
  return h
}

export const deleteUploadFile = (nodeID, fileName) => {
  const url = `/kuiper/${nodeID}/config/uploads/${fileName}`
  return http.delete(url)
}
